import { Box } from '@mui/material';
import type { ReactNode } from 'react';

type PipelineStatusObject = {
  statusLabel?: ReactNode;
  label?: ReactNode;
  statusColor?: string;
  color?: string;
};

const PipelineStatus = ({ object }: { object?: PipelineStatusObject | null }) => {
  if (!object || !object.statusLabel) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center">
      <Box
        sx={{
          border: '1px solid',
          backgroundColor: object.statusColor || object.color,
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          marginRight: '4px',
        }}
      />

      <Box>{object.statusLabel || object.label}</Box>
    </Box>
  );
};

export default PipelineStatus;
